import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

const AdminSettingsRewards = ({ onBack, selectedTurnirId }) => {
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [hasVeterans, setHasVeterans] = useState(false);

  // State za sve nagrade (seniorske i veteranske)
  const [rewards, setRewards] = useState({
    total_fund: "",
    first_place: "",
    second_place: "",
    third_place: "",
    first_place_veterani: "",
    second_place_veterani: "",
    third_place_veterani: "",
    best_player: "",
    best_scorer: "",
    best_gk: "",
  });

  // Učitaj podatke iz baze za odabrani turnir pri pokretanju
  useEffect(() => {
    const fetchRewards = async () => {
      if (!selectedTurnirId) {
        setFetching(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("admin_turniri")
          .select(
            "total_fund, first_place, second_place, third_place, first_place_veterani, second_place_veterani, third_place_veterani, best_player, best_scorer, best_gk, features",
          )
          .eq("id", selectedTurnirId)
          .maybeSingle();

        if (error) throw error;

        if (data) {
          // Provjera jesu li veterani uključeni u features JSON-u
          let featuresObj = {};
          try {
            featuresObj =
              typeof data.features === "string"
                ? JSON.parse(data.features)
                : data.features || {};
          } catch (e) {
            featuresObj = {};
          }
          setHasVeterans(!!featuresObj.veterani);

          setRewards({
            total_fund: data.total_fund || "",
            first_place: data.first_place || "",
            second_place: data.second_place || "",
            third_place: data.third_place || "",
            first_place_veterani: data.first_place_veterani || "",
            second_place_veterani: data.second_place_veterani || "",
            third_place_veterani: data.third_place_veterani || "",
            best_player: data.best_player || "",
            best_scorer: data.best_scorer || "",
            best_gk: data.best_gk || "",
          });
        }
      } catch (err) {
        console.error("Greška pri dohvaćanju nagrada:", err);
      } finally {
        setFetching(false);
      }
    };

    fetchRewards();
  }, [selectedTurnirId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRewards((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!selectedTurnirId || selectedTurnirId === "undefined") {
      alert("Greška: Nije odabran nijedan turnir.");
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase
        .from("admin_turniri")
        .update(rewards)
        .eq("id", selectedTurnirId);

      if (error) throw error;

      alert("Nagrade uspješno spremljene!");
      if (onBack) onBack();
    } catch (err) {
      console.error("Greška pri spremanju:", err);
      alert("Greška pri spremanju!");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="admin-settings-rewards">
        <p>Učitavam nagrade...</p>
      </div>
    );
  }

  return (
    <div className="admin-settings-rewards">
      <button className="back-btn" onClick={onBack}>
        <i className="fi fi-rs-arrow-left"></i> Natrag
      </button>

      <h3>Uredi Nagradni Fond</h3>

      <div className="admin-form">
        <div className="form-group">
          <label>Ukupni Fond (€)</label>
          <input
            type="text"
            name="total_fund"
            value={rewards.total_fund}
            onChange={handleChange}
            placeholder="npr. 6.000"
          />
        </div>

        {hasVeterans ? (
          <div className="rewards-split-container">
            {/* Lijeva strana - Seniori */}
            <div className="rewards-column">
              <h4>SENIORI</h4>
              <div className="form-group">
                <label>1. Mjesto (€)</label>
                <input
                  type="text"
                  name="first_place"
                  value={rewards.first_place}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>2. Mjesto (€)</label>
                <input
                  type="text"
                  name="second_place"
                  value={rewards.second_place}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>3. Mjesto (€)</label>
                <input
                  type="text"
                  name="third_place"
                  value={rewards.third_place}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Desna strana - Veterani */}
            <div className="rewards-column">
              <h4>VETERANI</h4>
              <div className="form-group">
                <label>1. Mjesto (€)</label>
                <input
                  type="text"
                  name="first_place_veterani"
                  value={rewards.first_place_veterani}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>2. Mjesto (€)</label>
                <input
                  type="text"
                  name="second_place_veterani"
                  value={rewards.second_place_veterani}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>3. Mjesto (€)</label>
                <input
                  type="text"
                  name="third_place_veterani"
                  value={rewards.third_place_veterani}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="form-row">
            <div className="form-group">
              <label>1. Mjesto (€)</label>
              <input
                type="text"
                name="first_place"
                value={rewards.first_place}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>2. Mjesto (€)</label>
              <input
                type="text"
                name="second_place"
                value={rewards.second_place}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>3. Mjesto (€)</label>
              <input
                type="text"
                name="third_place"
                value={rewards.third_place}
                onChange={handleChange}
              />
            </div>
          </div>
        )}

        <h4>Individualne Nagrade</h4>

        <div className="form-group">
          <label>Najbolji Igrač</label>
          <input
            type="text"
            name="best_player"
            value={rewards.best_player}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Najbolji Strijelac</label>
          <input
            type="text"
            name="best_scorer"
            value={rewards.best_scorer}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Najbolji Golman</label>
          <input
            type="text"
            name="best_gk"
            value={rewards.best_gk}
            onChange={handleChange}
          />
        </div>

        <button className="save-btn" onClick={handleSave} disabled={loading}>
          {loading ? "Spremanje..." : "Spremi promjene"}
        </button>
      </div>
    </div>
  );
};

export default AdminSettingsRewards;
